import {
  AI_MARKET_NEWS_PATH,
  NEWS_SYMBOLS_WITH_NEWS_PATH,
  NEWS_PERIOD_AI_ANALYSIS,
  NEWS_LAST_PERIOD_AI_ANALYSIS,
  TRACK_AI_MARKET_INSIGHT_VIEWED_PATH,
} from '../../../constants'
import AbstractService from '../../../services/AbstractService'
import { ServerResponse } from '../../../types'

import {
  NewsItem,
  FetchNewsParams,
  NewsPeriodAiAnalysis,
  GetNewsPeriodAiAnalysisData,
  NewsSymbol,
  TrackAiMarketInsightViewedData,
} from './types'

class AIMarketInsightsServiceClass extends AbstractService {
  getNews = (params: FetchNewsParams) =>
    this.request<ServerResponse<NewsItem[]>>(AI_MARKET_NEWS_PATH, 'post', false, params)

  getNewsPeriodAiAnalysis = (data: GetNewsPeriodAiAnalysisData) =>
    this.request<ServerResponse<NewsPeriodAiAnalysis[]>>(
      NEWS_PERIOD_AI_ANALYSIS,
      'post',
      false,
      data,
    )

  getSymbolsWithNews = () =>
    this.request<ServerResponse<NewsSymbol[]>>(NEWS_SYMBOLS_WITH_NEWS_PATH, 'get', false)

  getLastNewsPeriodAiAnalysis = (data: GetNewsPeriodAiAnalysisData) =>
    this.request<ServerResponse<NewsPeriodAiAnalysis[]>>(
      NEWS_LAST_PERIOD_AI_ANALYSIS,
      'post',
      false,
      data,
    )

  trackAiMarketInsightViewed = (data: TrackAiMarketInsightViewedData) =>
    this.request<ServerResponse<{ success: boolean }>>(
      TRACK_AI_MARKET_INSIGHT_VIEWED_PATH,
      'post',
      false,
      data,
    )
}

export const AIMarketInsightsService = new AIMarketInsightsServiceClass()
